<template>
  <v-row no-gutters>
    <v-col
      md="8"
      offset-md="2">
      <v-container class="page page--form">
        <bills-item-form :source="$route.params.source" />
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
//   import RESOURCES from '@batimentb/vadimm-js-api/resources'
  import BillsItemForm from '../components/BillsItemForm'

  export default {
    name: 'EditBillsItem',
    components: { BillsItemForm },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>

</style>
